module.exports = __webpack_public_path__ + "static/1316793260-wide.d729c0da.jpg";